import { BoxStyleProps } from "@twilio-paste/core/box";

export const formStyles: BoxStyleProps = {
    borderTopColor: "colorBorderWeaker",
    borderTopWidth: "borderWidth10",
    borderTopStyle: "solid",
    padding: "space20",
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    flexShrink: 0
};

export const innerInputStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    maxWidth: "100%",
    minWidth: "0",
    overflow: "hidden",
    boxSizing: "border-box"
};

export const textAreaContainerStyles: BoxStyleProps = {
    marginTop: "auto",
    marginBottom: "auto",
    flex: "1 1 auto",
    minWidth: "0",
    overflow: "hidden"
};

export const messageOptionContainerStyles: BoxStyleProps = {
    margin: "space30",
    marginLeft: "space20",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "left",
    flexShrink: 0,
    flexGrow: 0,

    _notLast: {
        marginRight: "space0"
    }
};

export const filePreviewContainerStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    maxHeight: "300px",
    position: "relative",
    paddingLeft: "space30",
    paddingRight: "space30"
};
